import { useDispatch } from 'react-redux'
import { action_cart_checkout, action_fetch_cart } from '../../../../../../store/actions/pages/cart'
import { TOOGLE_UI_ALERT } from '../../../../../../store/actions/ui'
import { useHistory } from 'react-router-dom'


export default () => {

    const dispatch = useDispatch()
    const history = useHistory()

    const applyCheckout = async () => {
        const checkout = await dispatch(action_cart_checkout())
        if (checkout?.error) {
            dispatch(action_fetch_cart())
            dispatch({
                type: TOOGLE_UI_ALERT,
                payload: {
                    show: true,
                    options: {
                        onConfirm: () => {
                            dispatch({ type: TOOGLE_UI_ALERT, payload: null })
                        },
                        content: checkout.error
                    }
                }
            })
        } else {
            if (checkout) {
                history.push('/cart/checkout')
            }
        }
        return checkout
    }

    return {
        applyCheckout
    }
}